import { FT5_VIEW_TRACKING } from '../../../constants';
import { emitTrackingEvent } from '../../../_common/client/tracking/emit-tracking-event';
import { BCT_TRACKING_ADD_TO_PI } from '../../../_common/client/bct-event-topics';

export function registerViewTracking() {
    o_global.eventQBus.on(FT5_VIEW_TRACKING, (trackingData: Record<string, Array<string>>) => {
        emitTrackingEvent(BCT_TRACKING_ADD_TO_PI, { ot_PageCluster: ['Kundenbewertungsseite'], ...trackingData });
    });
}
